import React from 'react';
import { Button, Modal } from 'antd';
import './reset-password-modal.scss';
import { useHistory } from 'react-router-dom';
var prefixCls = 'reset-password-modal';
var ResetPasswordModal = function (props) {
    var history = useHistory();
    var handleOk = function () {
        var _a;
        history.replace('/profile');
        sessionStorage.setItem('pwdCheck', '1');
        (_a = props.onOk) === null || _a === void 0 ? void 0 : _a.call(null);
    };
    return (React.createElement(Modal, { title: '修改密码', className: "" + prefixCls, visible: props.visible, width: props.width || 500, destroyOnClose: true, closeIcon: true, footer: [
            React.createElement(Button, { key: "submit", onClick: handleOk }, "\u7ACB\u5373\u66F4\u6539"),
        ] },
        React.createElement("div", null, "\u60A8\u7684\u5BC6\u7801\u8FC7\u4E8E\u7B80\u5355\uFF0C\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u4FEE\u6539\u5BC6\u7801\uFF01")));
};
export default React.memo(ResetPasswordModal);
